exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fc-event {\r\n  margin: 10px 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.mainspan{\r\n  margin-top: 100px;\r\n}\r\n.searchInput{\r\n  border: 2px solid;\r\n  min-width: 165px;\r\n  max-width: 166px;\r\n  padding-left: 5px;\r\n  margin: 0;\r\n\r\n}\r\n\r\n.yellowBorder{\r\n  border-color: yellow;\r\n}\r\n\r\n.greenBorder{\r\n  border-color: darkgreen;\r\n}\r\n\r\n.loader {\r\n  border: 16px solid #f3f3f3; /* Light grey */\r\n  border-top: 16px solid #3498db; /* Blue */\r\n  border-radius: 50%;\r\n  width: 160px;\r\n  height: 160px;\r\n  animation: spin 1s linear infinite;\r\n\r\n}\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n\r\n.pagination{\r\n  margin:0;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Projects/ePlanner Maintenance/src/app/controllers/calendars/popover-task/popover-task.component.css
// module id = ../../../../../src/app/controllers/calendars/popover-task/popover-task.component.css
// module chunks = main